import { Button } from "@chakra-ui/react";
import { t } from "i18next";
import { FaArrowRight } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import { useNegotiation } from "../NegotiationContext";

interface Props {
  size?: string;
}

export const GoToLatestRoundButton = ({ size = "md" }: Props) => {
  const { event, setRoundNumber } = useNegotiation();
  const [searchParams, setSearchParams] = useSearchParams();

  const getLatestRoundNumber = () => {
    if (!event.negotiationRounds?.length) return 0;
    return event.negotiationRounds.length;
  };

  const handleGoToLatestRound = () => {
    const latest = getLatestRoundNumber();
    setRoundNumber(latest);
    const params = new URLSearchParams(searchParams);
    if (latest === 0) {
      params.delete("negotiationRoundId");
    } else {
      const round = event.negotiationRounds?.[latest - 1];
      if (round?.id) params.set("negotiationRoundId", round.id);
    }
    setSearchParams(params);
  };

  return (
    <Button
      rightIcon={<FaArrowRight />}
      colorScheme="teal"
      variant="outline"
      size={size}
      onClick={handleGoToLatestRound}
      ml={2}
    >
      {t("Go to latest round")}
    </Button>
  );
};
